module.exports = __webpack_public_path__ + "img/6.29e98200.jpg";